module.exports = __webpack_public_path__ + "static/media/google_26.bb118a8b.svg";